import { GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
// import { clearfixStyles } from "@tecumseh/theme/mixins";
import { createGlobalStyle, css } from "styled-components";
import getProp from "@insite/mobius/utilities/getProp";

const CustomGlobalStyles = createGlobalStyle`
body {
    margin: 0;
    height: 100%;
    line-height: 1.5;
    font-size: ${getProp("theme.typography.body.size")};
    font-weight: ${getProp("theme.typography.body.weight")};
    color: ${getProp("theme.colors.text.main")};
    background: ${getProp("theme.colors.common.background")};
    .maxWidthClass{
        max-width: 100% !important;
        div[class^="GridOffset"]{
            width: 100% !important;
            margin: 0 !important;
        }
        ${GridItemStyle} {
            padding: 0 !important;
        }
    }
}
`;
export default CustomGlobalStyles;